import Marquee from "react-fast-marquee";
import { BRANDS } from "../data/content";

export const BrandMarquee = () => (
  <section data-testid="brand-marquee" className="relative py-16 border-y border-white/10 bg-charcoal-900">
    <p className="text-center text-[11px] uppercase tracking-[0.4em] text-cream/40 mb-10">
      Trusted by global brands &amp; agency groups
    </p>
    <Marquee gradient gradientColor="#0A0A0B" gradientWidth={120} speed={40} pauseOnHover>
      {BRANDS.map((b, i) => (
        <span
          key={i}
          className="font-serif text-3xl sm:text-4xl text-cream/35 hover:text-gold transition-colors duration-500 mx-10 whitespace-nowrap"
        >
          {b}
        </span>
      ))}
    </Marquee>
  </section>
);
